import { useQuery } from '@tanstack/react-query';
import { ActionPlansService } from '@/infra/services/action-plans';
import { QUERY_KEYS } from '@/utils/query-keys';

interface GetActionPlansByOriginParams {
	table_name: string;
	column_id: string;
	organization_id: string;
	company_id: string;
	limit?: number;
	offset?: number;
}

const Service = ActionPlansService.getInstance();

export function useGetActionPlansByOrigin(params: GetActionPlansByOriginParams) {
	return useQuery({
		queryKey: [QUERY_KEYS.GET_ACTION_PLANS_BY_ORIGIN, params],
		queryFn: async () => await Service.findAllByOrigin(params),
		enabled: !!params.organization_id && !!params.company_id && !!params.table_name && !!params.column_id
	});
}
